import React from 'react';
import { Props as ButtonProps } from '../POSButton/POSButton';
import POSButton from '../POSButton';
import './POSIconButton.less';
import { POSIcon, POSICons } from '../POSIcon/POSIcon';
import clsx from 'clsx';

export interface Props extends Omit<ButtonProps, 'icon'> {
  icon: POSICons;
  className?: string;
}

export const POSIconButton = (props: Props) => {
  return (
    <POSButton
      {...props}
      icon={true}
      className={clsx(
        { 'icon-only': props.iconOnly },
        !!props.className && props.className
      )}
    >
      <POSIcon icon={props.icon} />
      {props.children}
    </POSButton>
  );
};
